<template>
  <div class="menu">
    <span class="button-menu-back sprite-return" @click="$emit('backMenu')"/>
    <button-menu
      :label="dictionnary ? dictionnary.templateMenu.nouveau : ''"
      iconClass="sprite-templatesplus"
      @click.native="changeMenu('CreateTemplateMenu')"
    />
    <span class="separator"/>
    <scroller class="scroller-menu" :offset="20" :maxWidth="858">
      <button-template
        v-for="template in templatesList"
        :key="template.id"
        :template="template"
        :icon="template.icon"
        :label="template.name"
        @selectedTemplate="selectTemplate"
        @removeTemplate="removeTemplate"
      />
    </scroller>
  </div>
</template>
<script>
import menu from './menu-default'
import ButtonTemplate from '@/components/buttons/ButtonTemplate'
import ButtonMenu from '@/components/buttons/ButtonMenu'
import { EventBus, TEMPLATE_DELETING, TEMPLATE_LOADING, PAYMENT_INFO } from '@/model/EventBus'
import { not, defined } from 'junctions-fp'
import Scroller from '@/components/scroller/Scroller'
import HttpConnector from '../../model/http/HttpConnector'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'TemplatesMenu',
  mixins: [menu],
  components: {
    ButtonTemplate,
    Scroller,
    ButtonMenu
  },
  computed: {
    ...mapGetters(['templatesList', 'getLimitations'])
  },
  methods: {
    ...mapActions(['setCurrentTemplate','updateCurrentFormat', 'deleteTemplate']),
    async selectTemplate({id:templateId}) {
      if (not(defined(this.getLimitations.templateUse)) || !this.getLimitations.templateUse) {
        EventBus.$emit(PAYMENT_INFO, { type: 'infos', code: 'paymentContent', class: 'danger' })
        return
      }
      EventBus.$emit(TEMPLATE_LOADING)
      const templateInfo = await HttpConnector.getInstance().getTemplates(templateId)
      this.editor.loadTemplate(templateInfo)
      this.editor.changeFormat(templateInfo.width, templateInfo.height)
      this.setCurrentTemplate(templateInfo.id)
      const { format, width, height, network, font, icon, label} = templateInfo
      this.updateCurrentFormat({ format, width, height, network, font, icon, label} )
      this.changeMenu('DefaultMenu')
    },
    async removeTemplate(template) {
       EventBus.$emit(TEMPLATE_DELETING, template)
    },
  },
  watch: {}
}
</script>



// WEBPACK FOOTER //
// src/components/menu/TemplatesMenu.vue